import React from 'react';
import { Chip as MaterialChip, ChipProps, createStyles, withStyles } from '@material-ui/core';
import styleVariables from '@Styles/_variables.module.scss';

const StyledChip = withStyles(() =>
  createStyles({
    colorPrimary: {
      color: styleVariables.AFNavyBlue500,
      backgroundColor: styleVariables.AFNavyBlue200,
    },
    colorSecondary: {
      color: styleVariables.AFGraphite400,
      backgroundColor: styleVariables.AFSteel400,
    },
  }),
)(MaterialChip);

export const StatusChip: React.FC<ChipProps> = ({ ...props }) => {
  return <StyledChip {...props} />;
};
